const initialState = { isLoading: false, token: null, user: null };
const loginPending = (state) => ({
  ...state,
  isLoading: true,
  token: null,
  user: null
});
const loginFullfilled = (state, payload) => ({
  ...state,
  isLoading: false,
  token: payload?.payload?.data?.data?.token,
  user: payload?.payload?.data?.data?.user
});
const loginRejected = (state) => ({
  ...state,
  isLoading: false,
  token: null,
  user: null
});

export default function (state = initialState, action) {
  switch (action.type) {
    case 'LOGIN_PENDING':
      return loginPending(state, action);

    case 'LOGIN_FULFILLED':
      return loginFullfilled(state, action);

    case 'LOGIN_REJECTED':
      return loginRejected(state, action);

    default:
      return {
        ...state,
      };
  }
}
